import React, { useState } from 'react'
import 'animate.css/animate.compat.css';
import './admin/Sidebar.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// page imports
import Home from './components/Home';
import About from './components/About';
import Support from './components/Support';
import Contact from './components/Contact';
import Careers from './components/Careers';
import Services from './components/Services';
// general imports
import Header from './general/Header';
import ScrollTop from './general/ScrollTop';
import PageNotFound from './general/PageNotFound';
import Footer from './general/Footer';
import BillingSoftware from './components/BillingSoftware';
import HotelManagement from './components/HotelManagement';
import MlmSoftware from './components/MlmSoftware';
import FaceAttendance from './components/FaceAttendance';
import PrivacyPolicy from './components/PrivacyPolicy';
import Partners from './components/Partners';
import AdminLogin from './admin/AdminLogin';
import BDashboard from './admin/BDashboard';
import Sidebar from './admin/Sidebar';
import ManageUsers from './admin/ManageUsers';
import { Toaster } from 'react-hot-toast';
import BPlans from './admin/BPlans';
import HDashboard from './admin/HDashboard';
import HotelUsers from './admin/HotelUsers';


const App = () => {
  const product = localStorage.getItem('product');
        const [collapsed, setCollapsed] = useState(false);
console.log(product);
            const toggleSidebar = () => {
        setCollapsed(!collapsed);
    };

  return (
    <>
    <BrowserRouter>
    <ScrollTop />

     <Toaster position="top-right" />

    {!product &&
    <>
    
    <Header />
    <Routes>
    <Route exact path ='/' element={<Home />} />
    <Route exact path ='/about' element={<About />} />
    <Route exact path ='/services' element={<Services />} />
    <Route exact path ='/careers' element={<Careers />} />
    <Route exact path ='/contact' element={<Contact />} />
    <Route exact path ='/partners' element={<Partners />} />
    <Route exact path ='/support' element={<Support />} />
    <Route exact path ='/privacy-policy' element={<PrivacyPolicy />} />
    <Route exact path ='/billing-software' element={<BillingSoftware />} />
    <Route exact path ='/hotel-management' element={<HotelManagement />} />
    <Route exact path ='/mlm-software' element={<MlmSoftware />} />
    <Route exact path ='/face-attendance' element={<FaceAttendance />} />
    <Route exact path ='/admin-login' element={<AdminLogin />} />
    <Route exact path ='*' element={<PageNotFound />} />
    </Routes>
    <Footer />
    </>}


        {(product != null && product != 'Hotel Management') &&
    <>
    <Sidebar product={product} setCollapsed={setCollapsed} collapsed={collapsed}/>
      <div className={`sidebar-right ${collapsed ? "collapsed" : ""}`}>
<div className={`text-md-start ${collapsed ? 'text-end' : 'text-start'}`}>            <button className='sidebar-close'  onClick={toggleSidebar}>{collapsed ? <i className="fa-solid fa-angle-left"></i> : <i className="fa-solid fa-angle-right"></i>}</button></div>

     <Routes>
    <Route exact path ='/' element={<BDashboard product={product} />} />
    <Route exact path ='/admin/dashboard' element={<BDashboard product={product} />} />
    <Route exact path ='/admin/users' element={<ManageUsers product={product} />} />
    <Route exact path ='/admin/plans' element={<BPlans product={product} />} />


    <Route exact path ='*' element={<PageNotFound />} />
    </Routes>
    </div>
</>
}

{(product != null && product == 'Hotel Management') &&
    <>
    <Sidebar product={product} setCollapsed={setCollapsed} collapsed={collapsed}/>
      <div className={`sidebar-right ${collapsed ? "collapsed" : ""}`}>
<div className={`text-md-start ${collapsed ? 'text-end' : 'text-start'}`}>            <button className='sidebar-close'  onClick={toggleSidebar}>{collapsed ? <i className="fa-solid fa-angle-left"></i> : <i className="fa-solid fa-angle-right"></i>}</button></div>

     <Routes>
    <Route exact path ='/' element={<HDashboard product={product} />} />
    <Route exact path ='/admin/dashboard' element={<HDashboard product={product} />} />
    <Route exact path ='/admin/users' element={<HotelUsers product={product} />} />

    <Route exact path ='*' element={<PageNotFound />} />
    </Routes>
    </div>
</>
}
    </BrowserRouter>
    </>
  )
}

export default App
